import React from "react";

import {
  BreadcrumbCurrent,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbNav,
} from "./StudentBreadcrumbs.styles";

export interface StudentBreadcrumbItem {
  label: string;
  to?: string;
}

interface StudentBreadcrumbsProps {
  items: StudentBreadcrumbItem[];
}

const StudentBreadcrumbs: React.FC<StudentBreadcrumbsProps> = ({ items }) => (
  <BreadcrumbNav aria-label="Хлебные крошки">
    <BreadcrumbList>
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1 || !item.to;
        return (
          <BreadcrumbItem key={`${item.to || "current"}-${index}`}>
            {isCurrent ? (
              <BreadcrumbCurrent aria-current="page" title={item.label}>
                {item.label}
              </BreadcrumbCurrent>
            ) : (
              <BreadcrumbLink to={item.to!} title={item.label}>
                {item.label}
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        );
      })}
    </BreadcrumbList>
  </BreadcrumbNav>
);

export default StudentBreadcrumbs;